/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Discount,
  DiscountNew,
} from '../models/index';
import {
    DiscountFromJSON,
    DiscountToJSON,
    DiscountNewFromJSON,
    DiscountNewToJSON,
} from '../models/index';

export interface CreateDiscountRequest {
    discountNew: DiscountNew;
}

export interface UpdateDiscountRequest {
    discountId: number;
    discountNew: DiscountNew;
}

/**
 * 
 */
export class DiscountsApi extends runtime.BaseAPI {

    /**
     */
    async createDiscountRaw(requestParameters: CreateDiscountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Discount>> {
        if (requestParameters['discountNew'] == null) {
            throw new runtime.RequiredError(
                'discountNew',
                'Required parameter "discountNew" was null or undefined when calling createDiscount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/discounts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscountNewToJSON(requestParameters['discountNew']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountFromJSON(jsonValue));
    }

    /**
     */
    async createDiscount(requestParameters: CreateDiscountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Discount> {
        const response = await this.createDiscountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDiscountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Discount>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/discounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DiscountFromJSON));
    }

    /**
     */
    async getDiscounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Discount>> {
        const response = await this.getDiscountsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDiscountRaw(requestParameters: UpdateDiscountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['discountId'] == null) {
            throw new runtime.RequiredError(
                'discountId',
                'Required parameter "discountId" was null or undefined when calling updateDiscount().'
            );
        }

        if (requestParameters['discountNew'] == null) {
            throw new runtime.RequiredError(
                'discountNew',
                'Required parameter "discountNew" was null or undefined when calling updateDiscount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/discounts/{discountId}`;
        urlPath = urlPath.replace(`{${"discountId"}}`, encodeURIComponent(String(requestParameters['discountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DiscountNewToJSON(requestParameters['discountNew']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDiscount(requestParameters: UpdateDiscountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDiscountRaw(requestParameters, initOverrides);
    }

}
